import { translateError } from '@kostbar/i18n'

/**
 * @deprecated Use `translateError` from `@kostbar/i18n` directly.
 * This function is kept for backwards compatibility.
 */
export function getErrorMessage(status: number, code?: string): string {
  return translateError(code, status)
}
